export default {
  props: {
    entity: Object,
    level: Number,
    defaultIcon: String,
    config: Object,
    details: Boolean,
    display: {
      type: String,
      default: 'display',
    },
    addSelectCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDetails: true,
      displayLevel: 2,
      selected: false,
    };
  },
  mounted() {
    this.setDefaultParams();
  },
  computed: {
    entityIcon() {
      switch (true) {
        case this.entity.icon != undefined:
          return this.entity.icon;

        case this.entity.img != undefined:
          return this.entity.img;
        case this.entity.avatar != undefined:
          return this.entity.avatar;
        case this.defaultIcon != undefined:
          return this.defaultIcon;
        default:
          return 'mdi-help-circle-outline';
      }
    },
    levelZero() {
      return this.getFieldsByLevel(0);
    },
    levelOne() {
      return this.getFieldsByLevel(1);
    },
    levelTwo() {
      return this.getFieldsByLevel(2);
    },
  },
  methods: {
    setDefaultParams() {
      this.showDetails = this.details ? this.details : true;
      this.displayLevel = this.level != undefined ? this.level : 2;
    },
    getFieldsByLevel(level) {
      let result = [];
      this.config[this.display].fields.forEach(field => {
        if (field.level === level) {
          result.push(field);
        }
      });
      return result;
    },
    entityDetail(id) {
      console.log(id);
      console.log(this.$router.currentRoute.path);
      this.$router.push(this.$router.currentRoute.path + '/' + id);
    },
  },
  watch: {
    selected: function() {
      this.$emit('checkbox-clicked', this.selected, this.entity);
    },
  },
};
